module.exports = __webpack_public_path__ + "static/photo12@2x-87a935d2151b37ae3b155109d45e0176.png";